import { useSearchParams } from "react-router-dom";
import { portfolioAnalysisPages } from "@app/const/route.const";
import { ModuleMultiPeriodReturnReport } from "./ModuleMultiPeriodReturnReport";

export const PdfPortfolioAnalysisMultiPeriodReturnReportPage = () => {
  const [searchParams] = useSearchParams();
  const { portfolioGroupId, moduleId, data1Id, data2Id } =
    portfolioAnalysisPages.getPdfMultiPeriodReturnReportParams(searchParams);

  return (
    <ModuleMultiPeriodReturnReport
      portfolioGroupId={portfolioGroupId}
      moduleId={moduleId}
      data1Id={data1Id}
      data2Id={data2Id}
      footer="Portfolio Analysis"
    />
  );
};
